import { render, staticRenderFns } from "./loginRecord.vue?vue&type=template&id=57be10e6&"
import script from "./loginRecord.vue?vue&type=script&lang=js&"
export * from "./loginRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports